import { createContext, useContext } from "react";
import type { ReactNode } from "react";

import type { Targeting } from "./types";

type ContextValue = {
  additionalTargeting: Targeting;
};

const AdSlotContext = createContext<ContextValue>({
  additionalTargeting: {},
});

type Props = {
  additionalTargeting: Targeting;
  children: ReactNode;
};

export const AdSlotContextProvider: React.FunctionComponent<Props> = ({
  additionalTargeting,
  children,
}) => <AdSlotContext.Provider value={{ additionalTargeting }}>{children}</AdSlotContext.Provider>;

AdSlotContextProvider.displayName = "AdSlotContextProvider";

export const useAdSlotContext = () => useContext(AdSlotContext);
